<template>
    <body style="direction: rtl; text-align: right;">
        <Header pageTitle="ترقية إلى مستقل" />
        <!-- **************** MAIN CONTENT START **************** -->
        <main>
            <div v-if="loading" class="loading-overlay">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div v-else>
                <!-- Container START -->
                <div class="container">
                    <router-link to="/profile" class="btn mb-3" style="background-color: #b1cedf; color: #000;">
                        عودة للبروفايل
                    </router-link>

                    <!-- كارد النموذج -->
                    <div class="form-card mb-4 p-3 rounded border shadow-sm">
                        <form @submit.prevent="submitForm">
                            <!-- حقل مخفي لـ usersid -->
                            <input type="hidden" id="usersid" v-model="formData.usersid" />

                            <div class="mb-3">
                                <label for="usersname" class="form-label">اسم المستخدم</label>
                                <input type="text" class="form-control" id="usersname" v-model="formData.usersname" required>
                            </div>
                            <div class="mb-3">
                                <label for="usersold" class="form-label">عمر المستخدم</label>
                                <input type="number" class="form-control" id="usersold" v-model="formData.usersold" required>
                            </div>
                            <div class="mb-3">
                                <label for="usersgender" class="form-label">جنس المستخدم</label>
                                <select class="form-control" id="usersgender" v-model="formData.usersgender" required>
                                    <option value="male">ذكر</option>
                                    <option value="female">أنثى</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label for="currentcountry" class="form-label">البلد الحالي</label>
                                <input type="text" class="form-control" id="currentcountry" v-model="formData.currentcountry" required>
                            </div>
                            <div class="mb-3">
                                <label for="image" class="form-label">تحميل صورة</label>
                                <input type="file" class="form-control" id="image" @change="handleFileUpload" accept="image/*" required>
                            </div>
                            <button type="submit" class="btn btn-primary">إرسال</button>
                        </form>
                    </div>
                </div>
                <Footer />
            </div>
        </main>
    </body>
</template>


<script>
import Header from '../../components/header.vue'; // تأكد من المسار الصحيح
import Footer from '../../components/footer.vue'; // تأكد من المسار الصحيح
import axios from 'axios';

export default {
    name: "CompleteProfile",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            loading: false, // مؤشر تحميل
            formData: {
                usersid: null, // سيتم تعيينه من localStorage
                usersold: "",
                usersgender: "",
                currentcountry: "",
                image: null, // سيتم تخزين الملف هنا
            },
        };
    },
    methods: {
        // دالة لالتقاط الملف المرفوع
        handleFileUpload(event) {
            this.formData.image = event.target.files[0]; // حفظ الملف المرفوع
        },
        // دالة لإرسال النموذج
        async submitForm() {
            this.loading = true; // تفعيل مؤشر التحميل
            try {
                const formData = new FormData();

                // إضافة البيانات إلى FormData بنفس الأسماء التي يتوقعها الخادم
                formData.append('usersid', this.formData.usersid);
                formData.append('usersold', this.formData.usersold);
                formData.append('usersgender', this.formData.usersgender);
                formData.append('currentcountry', this.formData.currentcountry);
                formData.append('image', this.formData.image); // إضافة الملف

                // إرسال البيانات باستخدام axios
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/add.php',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data', // تحديد نوع المحتوى
                        },
                    }
                );

                console.log("Data submitted successfully:", response.data);
                if (response.data.status === 'success') {
                    alert("تم إرسال البيانات بنجاح!");
                } else {
                    alert("حدث خطأ: " + response.data.message);
                }
            } catch (error) {
                console.error("There was an error submitting the form:", error);
                alert("حدث خطأ أثناء إرسال البيانات!");
            } finally {
                this.loading = false; // إيقاف مؤشر التحميل
            }
        },
    },
    mounted() {
        const userId = localStorage.getItem("userId");
        this.formData.usersid = userId ? parseInt(userId, 10) : null;
        console.log("User ID from localStorage:", this.formData.usersid);
    },
};
</script>


<style scoped>
.freelancer-page {
    height: 100vh;
    background-color: #ffffff;
}

.header {
    background-color: #296080;
    color: white;
}

.why-section ul {
    list-style-type: disc;
    padding-left: 20px;
}

.form-container {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
}

input,
textarea,
select {
    border-radius: 10px;
}
</style>
